import { Component } from '@angular/core';

@Component({
  selector: 'app-use-ocr-data',
  templateUrl: './use-ocr-data.component.html',
  styleUrls: ['./use-ocr-data.component.scss']
})
export class UseOcrDataComponent {
}
